import React, { useCallback, useEffect, useState } from "react";
import style from "./Cylinders.module.scss";
import { Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { LinearLoader } from "../../components/Loader/LinearLoader";
import Pagination from "../../components/paginationCopy/Pagination";
// import Search from "../../components/search";
import { loadCylinders } from "../../redux/admin/actions/admin.actions";
import { EyeOutlined } from "@ant-design/icons";
// import { SortButton } from "../../components/utils/sortButton";
import { ConfirmationModal } from "../../components/Modal/ConfirmationModal";
import Filter from "../../components/search/searchFilter/Filter";
import CylinderDetails from "./CylinderDetails";
import { SortButton } from "../../components/utils/sortButton";
// import AddBatch from "./addBatch/AddBatch.component";
// import { MyButton } from "../../Hooks/useButton";

const Cylinders = () => {
  const dispatch = useDispatch();
  const { cylinders } = useSelector((state) => state.adminReducer);

  const [loading, setLoading] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchKey, setSearchKey] = useState("");
  const [filteredData, setFilteredData] = useState(cylinders);

  useEffect(() => {
    setLoading(true);
    dispatch(loadCylinders());
    setLoading(false);
  }, [dispatch]);

  useEffect(() => {
    const results = cylinders?.filter((item) =>
      item[searchKey]?.toLowerCase()?.includes(searchTerm.toLowerCase())
    );
    setFilteredData(results);
  }, [cylinders, searchKey, searchTerm]);

  // pagination
  const [pageNumber, setPageNumber] = useState(0);
  const size = 10;
  const pagesVisited = pageNumber * size;
  const pageCount = Math.ceil(
    filteredData >= 1 ? filteredData?.length / size : cylinders?.length / size
  );

  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };

  const handleRow = (data) => {
    localStorage.setItem("code", data?.cylinder);
    setOpenModal(true);
  };

  // sorting
  const [sortKey, setSortKey] = useState("cylinder");
  const [sortOrder, setSortOrder] = useState("desc");

  function sortData({ tableData, sortKey, reverse }) {
    if (!sortKey) return tableData;

    const sortedData = filteredData.sort((a, b) => {
      return a[sortKey] > b[sortKey] ? 1 : -1;
    });

    if (reverse) {
      return sortedData.reverse();
    }

    return sortedData;
  }

  const sortedData = useCallback(
    () =>
      sortData({
        tableData: filteredData,
        sortKey,
        reverse: sortOrder === "desc",
      }),
    [filteredData, sortKey, sortOrder]
  );

  const headers = [
    { key: "index", label: "S/N" },
    { key: "cylinder", label: "Code" },
    { key: "Size", label: "Cylinder SIze" },
    { key: "location_name", label: "Last Known" },
    { key: "status", label: "Status" },
    { key: "since", label: "Days In/Out" },
    { key: "biker_name", label: "With" },
  ];

  const changeSort = (key) => {
    setSortOrder(sortOrder === "ascn" ? "desc" : "ascn");
    setSortKey(key);
  };

  const searchKeys = [
    { id: "cylinder", name: "Code" },
    { id: "location_name", name: "Hospital" },
    { id: "since", name: "Days" },
    { id: "biker_name", name: "Rider" },
  ];

  return (
    <>
      <div className='d-flex justify-content-between m-3'>
        <div></div>
        <Filter
          placeholder={"Search by"}
          filter={searchKey}
          options={searchKeys}
          onChange={(event) => {
            setSearchTerm(event.target.value);
          }}
          onChangeSelect={(event) => {
            setSearchKey(event.target.value);
          }}
        />{" "}
      </div>
      <section style={{ maxWidth: "95%", margin: "auto" }}>
        {loading && <LinearLoader />}
        <Table borderless responsive className='mt-4'>
          <thead>
            <tr className={style.TableHeadRow}>
              {headers?.map((row) => {
                return (
                  <td key={row?.key}>
                    {row?.label}{" "}
                    {filteredData?.length > 0 && (
                      <SortButton
                        bgColor={"#2784ef"}
                        columnKey={row.key}
                        onClick={() => changeSort(row.key)}
                        {...{ sortOrder, sortKey }}
                      />
                    )}
                  </td>
                );
              })}
            </tr>
          </thead>
          {loading ? (
            <LinearLoader />
          ) : filteredData?.length > 0 ? (
            <tbody>
              {sortedData()
                ?.slice(pagesVisited, pagesVisited + size)
                ?.map((hosp, index) => (
                  <tr
                    className={style.tableBodyRow}
                    key={hosp?.cylinder}
                    // onClick={() => handleRow(hosp)}
                  >
                    <td style={{ width: "7vw" }}>
                      {" "}
                      {pageNumber * size + index + 1}
                    </td>
                    <td style={{ width: "14vw" }}>{hosp?.cylinder}</td>
                    <td style={{ width: "12vw" }}>{hosp?.Size}</td>
                    <td style={{ width: "15vw" }}>{hosp?.location_name}</td>
                    <td style={{ width: "8vw" }}>{hosp?.status}</td>
                    <td style={{ width: "8vw" }}>{hosp?.since}</td>
                    <td style={{ width: "8vw" }}>
                      {hosp?.biker_name || "---"}
                    </td>

                    <td className='d-flex gap-3 justify-content-center align-items-center'>
                      <EyeOutlined
                        className={style.action}
                        style={{ color: "#213f7d", fontSize: "19px" }}
                        onClick={() => handleRow(hosp)}
                        // onClick={() => handleEdit(tick)}
                      />{" "}
                    </td>
                  </tr>
                ))}
            </tbody>
          ) : cylinders && searchTerm === "" ? (
            <tbody>
              {cylinders
                ?.slice(pagesVisited, pagesVisited + size)
                ?.map((hosp, index) => (
                  <tr
                    className={style.tableBodyRow}
                    key={hosp?.cylinder}
                    // onClick={() => handleRow(hosp)}
                  >
                    <td style={{ width: "7vw" }}>
                      {" "}
                      {pageNumber * size + index + 1}
                    </td>
                    <td style={{ width: "14vw" }}>{hosp?.cylinder}</td>
                    <td style={{ width: "12vw" }}>{hosp?.Size}</td>
                    <td style={{ width: "15vw" }}>{hosp?.location_name}</td>
                    <td style={{ width: "8vw" }}>{hosp?.status}</td>
                    <td style={{ width: "8vw" }}>{hosp?.since}</td>
                    <td style={{ width: "8vw" }}>
                      {hosp?.biker_name || "---"}
                    </td>

                    <td className='d-flex gap-3 justify-content-center align-items-center'>
                      <EyeOutlined
                        className={style.action}
                        style={{ color: "#213f7d", fontSize: "19px" }}
                        onClick={() => handleRow(hosp)}
                        // onClick={() => handleEdit(tick)}
                      />{" "}
                    </td>
                  </tr>
                ))}
            </tbody>
          ) : (
            <div className='d-flex justify-content-center align-items-center'>
              No record found
            </div>
          )}
        </Table>
        {(filteredData?.length < 1 && searchTerm === ""
          ? cylinders?.length > size
          : filteredData?.length > size) && (
          <Pagination pageCount={pageCount} onPageChange={changePage} />
        )}
      </section>

      {/* update Modal */}
      <ConfirmationModal
        open={openModal}
        handleClose={() => setOpenModal(false)}
        closemodal={() => setOpenModal(false)}
        bgcolor=' rgba(255, 255, 255, 0.92)'
        width='50vw'
        instruction={<CylinderDetails />}
      />
    </>
  );
};

export default Cylinders;
